export class YesNoRadio  {
       /** BLANK="" **/
    readonly BLANK : string = "";
    /** YES="1" **/
    readonly YES : string = "1";
    /** NO="2" **/
    readonly NO : string = "2";
    /** DONT_KNOW="3" **/
    readonly DONT_KNOW : string = "3";
}